import * as React from 'react';

import PrimaryLayout from '../layouts/PrimaryLayout';
import PageIntro from '../components/layout/PageIntro';
import PlatformCardGrid from '../components/layout/PlatformCardGrid';

const GetStartedPage: React.FunctionComponent = () => {
  const title = 'Get Started';
  const slug = '/getstarted/';
  const intro = 'Review steps for getting started with the library appropriate for your platform.';

  return (
    <PrimaryLayout title={title} path={slug}>
      <PageIntro title={title} intro={intro} path={slug} />
      <PlatformCardGrid link="getstarted" />
    </PrimaryLayout>
  );
};

export default GetStartedPage;
